const flowPath = {
  SAVE: '/simple/save'
}

const template = {
  complete: '你发起的${title}事项审批通过，请尽快查看！',
  reject: '你发起的${title}事项审批未通过，请尽快查看！',
  return: '你发起的${title}事项被退回，请尽快查看！',
  task: '${startUserName}发起的${title}事项，流转到${currTaskName}环节，请尽快办理！',
  cc: '${startUserName}发起的${title}事项，抄送了一份给您，请查阅！'
}

export {
  flowPath,
  template
}
